import { User } from "../types";

export const registerUser = (
  email: string,
  password: string,
  name: string
): boolean => {
  try {
    const users = getUsers();

    // Verificar se o usuário já existe
    if (users.find((user) => user.email === email)) {
      return false;
    }

    const newUser: User = {
      id: Date.now().toString(),
      email,
      password,
      name,
      createdAt: new Date(),
    };

    users.push(newUser);
    localStorage.setItem("users", JSON.stringify(users));
    return true;
  } catch (error) {
    console.error("Erro ao registrar usuário:", error);
    return false;
  }
};

export const loginUser = (email: string, password: string): User | null => {
  try {
    const users = getUsers();
    const user = users.find(
      (user) => user.email === email && user.password === password
    );

    if (user) {
      // Salvar usuário logado
      localStorage.setItem("currentUser", JSON.stringify(user));
      return user;
    }

    return null;
  } catch (error) {
    console.error("Erro ao fazer login:", error);
    return null;
  }
};

export const getCurrentUser = (): User | null => {
  try {
    const userStr = localStorage.getItem("currentUser");
    return userStr ? JSON.parse(userStr) : null;
  } catch (error) {
    console.error("Erro ao obter usuário atual:", error);
    return null;
  }
};

export const logoutUser = (): void => {
  localStorage.removeItem("currentUser");
};

export const getUsers = (): User[] => {
  try {
    const usersStr = localStorage.getItem("users");
    return usersStr ? JSON.parse(usersStr) : [];
  } catch (error) {
    console.error("Erro ao obter usuários:", error);
    return [];
  }
};

export const isAuthenticated = (): boolean => {
  return getCurrentUser() !== null;
};
